export default __webpack_public_path__ + "assets/footer-grove.as-path.9e5470a1.svg";